<template>
  <transition name="slide">
  <div v-show="this.showMenu" class="menu">
    <div class="menu-content">
      <a style="float:right; margin: 30px" tabindex="0" role="button" @keydown.space="close" @keydown.enter="close" @click="close" ref="closeButton"><img alt="Schließen der Navigation"
                                                               src="../assets/icons/BtnClose.svg"></a>
      <h1 class="menu-header">Das neue 5G-Netz <br>
        <span>Fragen und Antworten</span>
      </h1>
      <ul class="menu-list">
        <li v-for="i in this.infos" :key="i.id" @click="close" >
          <a :href="'#' + i.id" tabindex="-1"><img :src="i.thumbnail" :alt="'Gehe zu ' + i.headline"  tabindex="0"></a>
        </li>
      </ul>
    </div>
  </div>
  </transition>
</template>

<script>
export default {
  name: 'Menu',
  data: function () {
    return {
      lastFocusedElement: null,
      showMenu: false
    }
  },
  props: ['infos'],
  methods: {
    open () {
      // TODO: We should be able to set overflow hidden via the background-content class.
      // But somehow the class does not set the style if added to the body.
      // Therefore we set the style directly.
      // document.body.classList.toggle('background-content')
      this.lastFocusedElement = document.activeElement
      this.showMenu = true
      document.body.setAttribute('style', 'overflow:hidden')
      this.$nextTick(() => {
        this.$refs.closeButton.focus()
      })
    },
    close () {
      // TODO: toggle class instead.
      this.lastFocusedElement.focus()
      this.showMenu = false
      document.body.setAttribute('style', 'overflow:auto')
    }
  }
}
</script>

<style scoped lang="sass">

$menu-box-width: 145px
$grid-gap: 10px

.slide-enter-active
  animation-name: slidein
  animation-duration: 0.25s

.slide-leave-active
  animation-name: slideout
  animation-duration: 0.25s

@keyframes slidein
  from
    margin-left: 100%
  to
    margin-left: 0

@keyframes slideout
  from
    margin-left: 0
  to
    margin-left: 100%

.menu
  background-color: #294D71
  position: fixed
  top: 0
  left: 0
  bottom: 0
  right: 0
  z-index: 1
  width: 100vw

  .menu-content
    height: 100%
    overflow: scroll
    -webkit-overflow-scroll: touch
    img:focus
      border: 1px solid white

.menu-list
  margin: auto
  list-style: none
  padding-left: 0
  display: grid
  grid-gap: $grid-gap
  grid-template-columns: repeat(auto-fill, minmax($menu-box-width, 1fr))
  max-width: 2 * $menu-box-width + $grid-gap

</style>
